(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Accordion-with-Image-Section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('m-course-accordion')) {
    class MCourseAccordion extends HTMLElement {
      constructor() {
        super();
        this.onToggle = this.onToggle.bind(this);
      }

      connectedCallback() {
        this.addEventListener('toggle', this.onToggle, true);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.onToggle, true);
      }

      onToggle(event) {
        const tab = event.target;
        if (!tab.matches('details.awi-tab') || !tab.open || !tab.dataset.tabImage) return;
        const image = this.querySelector('.awi-right img[id^="awi-main-image-"]');
        if (!image) return;
        image.src = tab.dataset.tabImage;
        image.alt = tab.dataset.tabImageAlt || '';
        image.height = Number(tab.dataset.tabImageHeight) || image.height;
      }
    }
    customElements.define('m-course-accordion', MCourseAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
